import React from 'react';
import { Box, Typography } from '@mui/material';

const ColorWheel = ({ color, onChange }) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle1">Background Color:</Typography>
      <input
        type="color"
        value={color}
        onChange={(e) => onChange(e.target.value)}
        style={{ border: 'none', width: 50, height: 50 }}
      />
    </Box>
  );
};

export default ColorWheel;
